<template>
  <SectionContainerPage>
    <v-layout column>
      <v-flex>
        <SectionAssetDetail
          :title="titleComputed"
          :breadCrumbs="breadCrumbs"
          @onClickBreadcrumb="(val) => $emit('onClickBreadcrumb', val)"
          :toolbarActions="[
            {
              text: 'Edit Equipment',
              icon: 'edit',
              iconColor: 'warning',
              emitEvent: 'onEditEquipmentClicked',
            },
          ]"
          @onEditEquipmentClicked="showDialogFormAssetEdit = true"
          @onClickViewActivity="(val) => $emit('onClickViewActivity', val)"
          :assetDetail="assetDetail"
          :modelList="modelList"
          :manufacturerList="manufacturerList"
          :categoryList="categoryList"
          :activityTypeList="activityTypeList"
          :assetStatusList="assetStatusList"
          :locationList="locationList"
          :clientList="clientList"
          :userList="userList"
          :propertyKeyList="propertyKeyList"
          :isLoading="isLoading"
        />
      </v-flex>
      <v-flex>
        <v-tabs dark v-model="currentTab">
          <v-tab>
            <v-icon class="mr-1">event</v-icon
            >{{
              `Activities (${
                (assetDetail.activityList && assetDetail.activityList.length) ||
                0
              })`
            }}
          </v-tab>
          <v-tab>
            <v-icon class="mr-1">attachment</v-icon
            >{{
              `Attachments (${
                (assetDetail.attachmentList &&
                  assetDetail.attachmentList.length) ||
                0
              })`
            }}
          </v-tab>
          <v-tab>
            <v-icon class="mr-1">list_alt</v-icon
            >{{
              `Properties (${
                (assetDetail.propertyList && assetDetail.propertyList.length) ||
                0
              })`
            }}
          </v-tab>
        </v-tabs>
      </v-flex>
      <v-flex v-if="currentTab === tabActivities">
        <SectionActivityList
          xs12
          :isPrimary="false"
          :toolbarActions="[
            {
              text: 'Activity',
              icon: 'add',
              iconColor: 'success',
              emitEvent: 'onAddNewActivityClicked',
            },
          ]"
          @onAddNewActivityClicked="showDialogFormActivityAdd = true"
          :activityList="assetDetail.activityList || []"
          :activityTypeList="activityTypeList"
          :locationList="locationList"
          :userList="userList"
          :modelList="modelList"
          :assetStatusList="assetStatusList"
          title="Activities"
          @onClickViewActivity="
            (val) =>
              $emit('onClickViewActivityFromAssetDetail', {
                ...val,
                breadCrumbTitle: titleComputed,
              })
          "
          :isLoading="isLoading"
        />
      </v-flex>
      <v-flex v-if="currentTab === tabAttachments">
        <SectionAttachmentList
          xs12
          :isPrimary="false"
          @onClickViewAttachment="
            (val) =>
              $emit('onClickViewAttachmentFromAssetDetail', {
                ...val,
                breadCrumbTitle: titleComputed,
              })
          "
          :assetDetail="assetDetail"
          :attachmentList="assetDetail.attachmentList || []"
          :activityTypeList="activityTypeList"
          :userList="userList"
          :locationList="locationList"
          :modelList="modelList"
          :isLoading="isLoading"
        />
      </v-flex>
      <v-flex v-if="currentTab === tabProperties">
        <SectionPropertyList
          xs12
          :isPrimary="false"
          :toolbarActions="[
            {
              text: 'Property',
              icon: 'add',
              iconColor: 'success',
              emitEvent: 'onAddNewPropertyClicked',
            },
          ]"
          @onAddNewPropertyClicked="showDialogFormAssetPropertyAdd = true"
          @onEditPropertyClicked="
            (val) => [
              (propertyToEdit = val.propertyToEdit),
              (showDialogFormAssetPropertyEdit = true),
            ]
          "
          @onRemovePropertyClicked="(val) => onConfirmRemoveProperty(val)"
          :propertyList="assetDetail.propertyList || []"
          :propertyKeyList="propertyKeyList"
          :isLoading="isLoading"
        />
      </v-flex>
    </v-layout>
    <DialogFormAssetEdit
      :assetDetail="assetDetail"
      :showDialog="showDialogFormAssetEdit"
      @onCancelClicked="showDialogFormAssetEdit = false"
      @onSubmitClicked="
        (val) => [
          onDialogFormAssetEditSubmit(val),
          (showDialogFormAssetEdit = false),
        ]
      "
      :modelList="modelList"
      :manufacturerList="manufacturerList"
      :categoryList="categoryList"
      :locationList="locationList"
      :clientList="clientList"
      :isLoading="isLoading"
    />
    <DialogFormActivityAdd
      :showDialog="showDialogFormActivityAdd"
      @onCancelClicked="showDialogFormActivityAdd = false"
      @onSubmitClicked="(val) => [onDialogFormActivityAddSubmit(val)]"
      :selectedAssets="[assetDetail]"
      :clientList="clientList"
      :activityTypeList="activityTypeList"
      :userList="userList"
      :locationList="locationList"
      :modelList="modelList"
      :assetStatusList="assetStatusList"
      :isLoading="isLoading"
    />
    <DialogFormAssetPropertyAdd
      :showDialog="showDialogFormAssetPropertyAdd"
      @onCancelClicked="showDialogFormAssetPropertyAdd = false"
      @onSubmitClicked="
        (val) => [
          onDialogFormAssetPropertyAddSubmit(val),
          (showDialogFormAssetPropertyAdd = false),
        ]
      "
      :propertyKeyList="propertyKeyList"
      :assetDetail="assetDetail"
      :isLoading="isLoading"
    />
    <DialogFormAssetPropertyEdit
      :showDialog="showDialogFormAssetPropertyEdit"
      @onCancelClicked="showDialogFormAssetPropertyEdit = false"
      @onSubmitClicked="
        (val) => [
          onDialogFormAssetPropertyEditSubmit(val),
          (showDialogFormAssetPropertyEdit = false),
        ]
      "
      :propertyKeyList="propertyKeyList"
      :propertyToEdit="propertyToEdit"
      :isLoading="isLoading"
    />
    <DialogFormConfirmation
      :showDialog="confirmationDialogShow"
      :title="confirmationDialogTitle"
      :message="confirmationDialogMessage"
      :submitButtonText="confirmationDialogSubmitButtonText"
      :submitButtonIcon="confirmationDialogSubmitButtonIcon"
      :submitButtonColor="confirmationDialogSubmitButtonColor"
      :cancelButtonText="confirmationDialogCancelButtonText"
      :showCancelButton="confirmationDialogShowCancelButton"
      @onSubmitClicked="onConfirmationDialogSubmitClicked"
      @onCancelClicked="onConfirmationDialogCancelClicked"
      :isLoading="isLoading"
    />
  </SectionContainerPage>
</template>

<script>
import mixinAssetApi from '../../../common/mixins/mixinAssetApi'
import mixinAssetHelper from '../../../common/mixins/mixinAssetHelper'
import mixinConfirmationDialog from '../../../common/mixins/mixinConfirmationDialog'

import SectionContainerPage from '../../../common/components/layouts/SectionContainerPage'
import SectionAssetDetail from './sections/SectionAssetDetail'
import SectionActivityList from './sections/SectionActivityList'
import SectionAttachmentList from './sections/SectionAttachmentList'
import SectionPropertyList from './sections/SectionPropertyList'

import DialogFormAssetEdit from '../dialogs/DialogFormAssetEdit'
import DialogFormActivityAdd from '../dialogs/DialogFormActivityAdd'
import DialogFormAssetPropertyAdd from '../dialogs/DialogFormAssetPropertyAdd'
import DialogFormAssetPropertyEdit from '../dialogs/DialogFormAssetPropertyEdit'
import DialogFormConfirmation from '../dialogs/DialogFormConfirmation'

const TAB_ACTIVITIES = 0
const TAB_ATTACHMENTS = 1
const TAB_PROPERTIES = 2

export default {
  components: {
    SectionContainerPage,
    SectionAssetDetail,
    SectionActivityList,
    SectionAttachmentList,
    SectionPropertyList,
    DialogFormAssetEdit,
    DialogFormActivityAdd,
    DialogFormAssetPropertyAdd,
    DialogFormAssetPropertyEdit,
    DialogFormConfirmation,
  },
  mixins: [mixinAssetApi, mixinAssetHelper, mixinConfirmationDialog],
  props: {
    assetId: {
      type: Number,
      required: true,
    },
    breadCrumbs: Array,
  },
  data: () => ({
    currentTab: TAB_ACTIVITIES,
    tabActivities: TAB_ACTIVITIES,
    tabAttachments: TAB_ATTACHMENTS,
    tabProperties: TAB_PROPERTIES,
    showDialogFormAssetEdit: false,
    showDialogFormActivityAdd: false,
    showDialogFormAssetPropertyAdd: false,
    showDialogFormAssetPropertyEdit: false,
    assetDetail: {},
    propertyToEdit: {},
    modelList: [],
    manufacturerList: [],
    categoryList: [],
    activityTypeList: [],
    locationList: [],
    clientList: [],
    userList: [],
    assetStatusList: [],
    propertyKeyList: [],
    isLoadingCount: 0,
  }),
  activated() {
    this.currentTab = this.tabActivities
    this.fetchAssetDetail()
    this.fetchPropertyList()
    this.fetchLists()
  },
  computed: {
    isLoading() {
      return this.isLoadingCount > 0
    },
    titleComputed() {
      return (
        '' +
        this.assetDetail.name +
        ' - ' +
        this._entityPropertyValueByName({
          entityList: this.modelList,
          idKey: 'id',
          idValue: this.assetDetail.modelId,
          propertyKey: 'name',
          emptyText: ' ',
        })
      )
    },
  },
  watch: {
    assetId() {
      this.currentTab = this.tabActivities
      this.fetchAssetDetail()
      this.fetchPropertyList()
      this.fetchLists()
    },
    isLoading() {
      this.$emit('isLoadingChange', this.isLoading)
    },
  },
  methods: {
    onConfirmRemoveProperty({ propertyId, key, value } = {}) {
      this.showConfirmationDialog({
        message: `Please confirm you would like to remove remove [${key} => ${value}] from ${this.assetDetail.name}.`,
        submitButtonText: 'Delete',
        submitButtonIcon: 'delete_forever',
        submitButtonColor: 'error',
        toolbarActions: [
          {
            text: 'Delete',
            buttonColor: 'error',
            emitEvent: this.CONFIRMATION_DIALOG_SUBMIT_EVENT,
          },
          {
            text: 'CANCEL',
            emitEvent: this.CONFIRMATION_DIALOG_CLOSE_EVENT,
          },
        ],
        submitCb: () => {
          this.isLoadingCount++
          this._deleteProperty({
            id: propertyId,
            successCb: () => {
              this.isLoadingCount--
              this.fetchAssetDetail()
              this.$emit('notify', {
                message: 'Property successfully deleted!',
              })
            },
            failedCb: (error) => {
              this.isLoadingCount--
              this.showConfirmationDialog({
                title: 'Error occured',
                showCancelButton: false,
                message: this._getMessageFromErrorResponse(error),
                submitButtonText: 'Continue',
              })
            },
          })
        },
        cancelCb: () => {},
      })
    },
    onDialogFormAssetPropertyAddSubmit(data) {
      this.isLoadingCount++
      this._insertProperty({
        assetId: this.assetId,
        key: data.key,
        value: data.value,
        successCb: () => {
          this.isLoadingCount--
          this.fetchAssetDetail()
          this.$emit('notify', { message: 'Property successfully created!' })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    onDialogFormAssetPropertyEditSubmit(data) {
      this.isLoadingCount++
      this._updateProperty({
        id: data.id,
        key: data.key,
        value: data.value,
        successCb: () => {
          this.isLoadingCount--
          this.fetchAssetDetail()
          this.$emit('notify', { message: 'Property successfully updated!' })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    onDialogFormAssetEditSubmit(data) {
      this.isLoadingCount++
      this._updateAsset({
        id: data.id,
        name: data.name,
        clientId: data.clientId,
        modelId: data.modelId,
        comments: data.comments,
        successCb: () => {
          this.isLoadingCount--
          this.fetchAssetDetail()
          this.$emit('notify', { message: 'Equipement successfully updated!' })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    onDialogFormActivityAddSubmit(data) {
      this.isLoadingCount++
      this._insertActivity({
        assetIds: data.assetIds,
        statusId: data.statusId,
        typeId: data.typeId,
        dateTimeEpochPerformedOn: data.dateTimeEpochPerformedOn,
        userIdPerformedBy: data.userIdPerformedBy,
        locationId: data.locationId,
        files: data.files,
        comments: data.comments,
        successCb: () => {
          this.showDialogFormActivityAdd = false
          this.isLoadingCount--
          this.fetchAssetDetail()
          this.$emit('notify', { message: 'Activity successfully created!' })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    fetchAssetDetail() {
      this.isLoadingCount++
      this._fetchAssetDetail({
        assetId: this.assetId,
        successCb: (data) => {
          this.isLoadingCount--
          this.assetDetail = data
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    fetchPropertyList() {
      this.isLoadingCount++
      this._fetchPropertyKeyList({
        successCb: (data) => {
          this.isLoadingCount--
          this.propertyKeyList = data
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    fetchLists() {
      this.isLoadingCount++
      this._fetch({
        types: [
          'Status',
          'Model',
          'Manufacturer',
          'Category',
          'ActivityType',
          'Location',
          'Client',
          'User',
        ],
        successCb: (data) => {
          this.isLoadingCount--
          this.modelList = data.models
          this.manufacturerList = data.manufacturers
          this.categoryList = data.categories
          this.activityTypeList = data.activityTypes
          this.assetStatusList = data.statuses
          this.locationList = data.locations
          this.clientList = data.clients
          this.userList = data.users
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.assetStatusList = []
          this.modelList = []
          this.manufacturerList = []
          this.categoryList = []
          this.activityTypeList = []
          this.locationList = []
          this.clientList = []
          this.userList = []
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
  },
}
</script>
